// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const NoteIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M8.37 1.5h9.4c2.6.1 4.6 2.21 4.59 4.8v11.4c.06 2.59-2 4.74-4.6 4.8h-9.3c-2.14 0-3.97-1.47-4.52-3.46-.04-.13.07-.26.2-.26l2.14-.06c.46 0 .83-.37.83-.83s-.37-.83-.83-.83H4.01q-.2-.02-.22-.2l-.02-.5v-2.61c0-.12.1-.22.22-.22h2.3c.45 0 .82-.37.82-.83s-.37-.83-.83-.83H4c-.12 0-.22-.1-.22-.22v-3.1c0-.11.1-.21.22-.21h2.3c.45 0 .82-.37.82-.83s-.37-.83-.83-.83H4.01q-.2-.02-.22-.22v-.48c.05-1.13.49-2.2 1.28-3.03.87-.9 2.04-1.42 3.3-1.45"
        opacity=".5"
      />
      <path
        fillRule="evenodd"
        d="M1.64 6.8c0-.45.37-.82.83-.82h3.67c.46 0 .83.37.83.83s-.37.83-.83.83H2.47c-.46 0-.83-.38-.83-.83m0 5.2c0-.46.37-.83.83-.83h3.67c.46 0 .83.37.83.83s-.37.83-.83.83H2.47c-.46 0-.83-.37-.83-.83m0 5.2c0-.47.37-.84.83-.84h3.67c.46 0 .83.37.83.83s-.37.83-.83.83H2.47c-.46 0-.83-.37-.83-.83"
      />
    </g>
  </SvgIcon>
);

export default NoteIcon;
